import { elementStyle } from "./types";

type Props = {
  obj: TransformedDataProps;
  main?:boolean
};

const HandleObj = (props: Props) => {
  const { obj,main } = props;
  return (
    <>
      {Object.entries(obj).map(([key, value]) => (
        <div
          key={key}
          style={main ? elementStyle : { width: "100%", display: "flex" }}
        >
          <strong
            style={{
              textTransform: "capitalize",
              whiteSpace: "nowrap",
              color: "rgb(15, 169, 240)",
              width: "20%",
            }}
          >
            {key} :
          </strong>{" "}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: "0",
              gap: "4px",
              width: "80%",
              alignItems: "flex-end",
              justifyContent: "flex-end",
            }}
          >
            {value}
          </div>
        </div>
      ))}
    </>
  );
};
export default HandleObj;
